/* unplugin-vue-components disabled */import { render } from "./CustomerEdit.vue?vue&type=template&id=3d57ec57&ts=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=ts"
export * from "./CustomerEdit.vue?vue&type=script&lang=ts"

import "./CustomerEdit.vue?vue&type=style&index=0&id=3d57ec57&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__